// CDN configurations
const RESOURCE_CDN = 'https://resource-cdn.mindstamp.com'
// const PUB_CDN = 'https://pub-cdn.mindstamp.com'
const PUB_CDN = 'https://mindstamp-pub.b-cdn.net'

const PROD_CDN = 'https://prod-cdn.mindstamp.com'
// 
/**
* Transform image URL to use CDN paths
* @param {string} url - Original image URL
* @returns {string} CDN optimized URL
*/
export function cdnImageUrl(url) {
  // log.info(5,"🌜 cdnImageUrl", url)
 if (!url) return ''
 if (url.toString().includes('.gif')) return url
 if (url === '?optimizer=image' || url === '?optimizer=image&optimizer=image') return ''

 let result = url.toString()
 result = result.replaceAll("optimize=image", "")

 // Add S3 prefix if needed
 if (!result.includes('http')) {
   result = `https://mindstamp-prod.s3.us-west-1.amazonaws.com${url}`
 }

 // Replace pub CDN paths
 result = result.replaceAll('https://mindstamp-pub.imgix.net', PUB_CDN)
 result = result.replaceAll('https://mindstamp-pub.s3.us-west-1.amazonaws.com', PUB_CDN)
 result = result.replaceAll('https://mindstamp-pub.s3.us-west-2.amazonaws.com', PUB_CDN)
 result = result.replaceAll('https://mindstamp-pub.s3.us-west-3.amazonaws.com', PUB_CDN)

 // Replace resource CDN paths
 result = result.replaceAll('https://mindstamp-resources.s3.us-west-1.amazonaws.com', RESOURCE_CDN)
 result = result.replaceAll('https://mindstamp-resources.s3.us-west-2.amazonaws.com', RESOURCE_CDN)

// Replace prod CDN paths
result = result.replaceAll('https://mindstamp-prod.s3.us-west-1.amazonaws.com', PROD_CDN)
result = result.replaceAll('https://mindstamp-prod.s3.us-west-2.amazonaws.com', PROD_CDN)
result = result.replaceAll('https://mindstamp-prod.s3.us-west-3.amazonaws.com', PROD_CDN)

 return result
}

/**
* Get integration logo image URL
* @param {string} path - Integration identifier
* @returns {string} Integration logo URL
*/
export function getIntegrationImage(path) {
 const integrationImages = {
   'facebook': 'https://mspb.b-cdn.net/fb.png',
   'hubspot': `${RESOURCE_CDN}/assets/images/integrations/logos/hubspot.svg`,
   'zapier': `${RESOURCE_CDN}/assets/images/integrations/logos/zapier.png`,
   'google-analytics': `${RESOURCE_CDN}/assets/images/integrations/logos/ga.png`,
   'shopify': `${RESOURCE_CDN}/assets/images/integrations/logos/shopify.png`,
   'synthesia': `${RESOURCE_CDN}/assets/images/integrations/logos/synthesia.png`,
   'webhooks': `${RESOURCE_CDN}/logos/v2/full/color.png`,
   'open-ai': `${RESOURCE_CDN}/assets/images/integrations/logos/openai.png`,
   'constant-contact': `${RESOURCE_CDN}/assets/images/integrations/logos/cc.svg`,
   'stripe': `${RESOURCE_CDN}/assets/images/integrations/logos/stripe.png`,
   'google_drive': `https://mspb.b-cdn.net/drive_logo.png`,
   'clickfunnels': `https://mspb.b-cdn.net/cf.jpg`,
 }

 return integrationImages[path.toLowerCase()] || 'none'
}

/**
* Get integration icon URL
* @param {string} path - Integration identifier
* @returns {string} Integration icon URL
*/
export function getIntegrationIcon(path) {
 const integrationIcons = {
   'facebook': 'https://upload.wikimedia.org/wikipedia/commons/c/cd/Facebook_logo_%28square%29.png',
   'upload': `${RESOURCE_CDN}/assets/images/icons/loop-blue.png`,
   'link': 'https://cdn.mindstamp.com/7471685.png',
   'vimeo': `${RESOURCE_CDN}/assets/images/vimeo.png`,
   'wistia': `${RESOURCE_CDN}/assets/images/wistia.png`,
   'synthesia': `${RESOURCE_CDN}/assets/images/synthesia.png`,
   'heygen': 'https://cdn.mindstamp.com/heygen.png',
   'loom': 'https://cdn.mindstamp.com/loom.png',
   'panopto': 'https://cdn.mindstamp.com/panop.png',
   'kaltura': 'https://inplayer.com/wp-content/uploads/2018/04/kaltura-icon.png',
   'youtube': `${RESOURCE_CDN}/assets/images/youtube.png`,
   'stock': 'https://cdn.mindstamp.com/1e73e5cb95b89f1dce8b59c5236ca1fc28c7113b.png',
   'samples': `${RESOURCE_CDN}/assets/images/samples.png`,
   'jwplayer': 'https://cdn.theorg.com/91a26bb0-a507-4d8f-b5f8-538e89375ad1_medium.jpg',
   'twitter': 'https://cdn.mindstamp.com/xlogo.png',
   'linkedin': 'https://cdn-icons-png.flaticon.com/512/174/174857.png',
   'gmail': 'https://cdn-icons-png.flaticon.com/512/5968/5968534.png',
   'whatsapp': 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/2062095_application_chat_communication_logo_whatsapp_icon.svg/1200px-2062095_application_chat_communication_logo_whatsapp_icon.svg.png',
   'samples': `https://mspb.b-cdn.net/playgreen.jpeg`,
   'google_drive': `https://mspb.b-cdn.net/drive.png`,

 }

 return integrationIcons[path.toLowerCase()] || ''
}

/**
* Get video thumbnail URL
* @param {Object} design - Video design object
* @returns {string} Thumbnail URL
*/
export function getVideoThumbnail(design) {
 return design.thumbnail || getDefaultVideoThumbnail()
}

/**
* Get default video thumbnail URL
* @returns {string} Default thumbnail URL
*/
export function getDefaultVideoThumbnail() {
 return 'https://beanscafe.org/wp-content/uploads/2021/04/Video-Placeholder.jpg'
}

/**
 * Generate a contrasting color for text readability
 * @param {string} hexColor - Hex color code (with or without # prefix)
 * @param {number} threshold - Brightness threshold (0-255, default 128)
 * @returns {string} Contrasting hex color (#ffffff or #000000)
 */
export function getContrastingColor(hexColor, threshold = 128) {
  // Remove # if present
  const hex = hexColor.replace('#', '');
  
  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Calculate perceived brightness using the formula:
  // (0.299*R + 0.587*G + 0.114*B)
  // This accounts for human perception of different colors
  const brightness = (0.299 * r + 0.587 * g + 0.114 * b);
  
  // Return black or white based on brightness
  return brightness > threshold ? '#000000' : '#ffffff';
}

/**
* Generate a color from text input
* @param {string} text - Input text
* @returns {string} Generated hex color
*/
export function getColorFromText(text) {
 if (!text) return ''

 let hash = 0
 for (let i = 0; i < text.length; i++) {
   hash = text.charCodeAt(i) + ((hash << 5) - hash)
 }

 let color = '#'
 for (let i = 0; i < 3; i++) {
   const value = (hash >> (i * 8)) & 0xFF
   const scaled = Math.floor(64 + (value % 192))
   color += scaled.toString(16).padStart(2, '0')
 }

 return color
}

/**
* Generate a gradient from text input
* @param {string} str - Input text
* @returns {string} CSS gradient string
*/
export function stringToGradient(str) {
 if (!str) return ''

 let hash1 = 0
 let hash2 = 0
 
 for (let i = 0; i < str.length; i++) {
   hash1 = str.charCodeAt(i) + ((hash1 << 5) - hash1)
   hash2 = str.charCodeAt(i) + ((hash2 << 3) - hash2)
 }

 const generateColor = (hash) => '#' + Array.from({ length: 3 }).map((_, i) => {
   const value = (hash >> (i * 8)) & 0xFF
   const scaled = Math.floor(64 + (value % 192))
   return scaled.toString(16).padStart(2, '0')
 }).join('')

 const color1 = generateColor(hash1)
 const color2 = generateColor(hash2)
 
 return `linear-gradient(135deg, ${color1}, ${color2})`
}


/**
 * Generate a contrasting color for text on gradients
 * @param {string} gradientString - CSS gradient string
 * @param {number} threshold - Brightness threshold (0-255, default 128)
 * @returns {string} Contrasting hex color
 */
export function getGradientContrastingColor(gradientString, threshold = 128) {
  // Extract hex colors from gradient string
  const hexColors = gradientString.match(/#[0-9a-f]{6}/gi) || [];
  
  if (hexColors.length === 0) return '#000000';
  
  // Calculate average RGB values across all gradient colors
  let totalR = 0, totalG = 0, totalB = 0;
  
  hexColors.forEach(hexColor => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    totalR += r;
    totalG += g;
    totalB += b;
  });
  
  const avgR = totalR / hexColors.length;
  const avgG = totalG / hexColors.length;
  const avgB = totalB / hexColors.length;
  
  // Calculate brightness of the average color
  const brightness = (0.299 * avgR + 0.587 * avgG + 0.114 * avgB);
  
  // Return black or white based on brightness
  return brightness > threshold ? '#000000' : '#ffffff';
}